import React from "react";
import { Card, Col, Container, Placeholder, Row } from "react-bootstrap";

const HomePlaceholder = () => {
  const items = {
    item1: [1, 2, 3],
    item2: [1, 2, 3],
    item3: [1, 2, 3],
  };

  return (
    <>
      {Object.keys(items).map((key) => (
        <Row key={key}>
          <Row className="p-5">
            {items[key].map((item, index) => (
              <Col key={index} sm={12} md={6} lg={4} className="ml-5 mr-5 p-3">
                <Card style={{ width: "100%" }}>
                  <Card.Body>
                    <Placeholder
                      as={Card.Subtitle}
                      animation="glow"
                      className="text-start"
                    >
                      <Placeholder xs={4} md={4} lg={4} />
                    </Placeholder>

                    <Placeholder
                      as={Card.Title}
                      animation="glow"
                      className="text-start mt-3"
                    >
                      <Placeholder xs={6} md={6} lg={6} />
                    </Placeholder>

                    <Placeholder
                      as={Card.Text}
                      animation="glow"
                      className="mt-5"
                    >
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                      <Placeholder xs={12} md={12} lg={12} />
                    </Placeholder>

                    <Placeholder.Button
                      variant="primary"
                      xs={12}
                      md={12}
                      lg={12}
                      className="text-center"
                    />
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Row>
      ))}
    </>
  );
};

export default HomePlaceholder;
